<template>
  <el-dialog :visible.sync="showPopup" title="Bạn có tài khoản hết hạn liên kết với Zalo" :destroy-on-close="true">
    <div class="mx-3 my-1">
      <div class="small-scrollbar" style="overflow-y: auto; min-height: 300px; max-height: 300px;">
      <div class="fw-bold font-size-15 text-muted" v-for="(acc, index) in accounts" :key="index">
        {{ acc.zaloName }}
      </div>
     </div>
      <div class="font-size-14 fst-italic mt-2">
      </div>
      <div class="m-1" style="border-top: #EEE 2px solid" />
      <div class="mb-3 d-flex justify-content-end mt-2">
        <el-button size="mini" type="primary" @click="reLogin()">Liên kết lại</el-button>
        <el-button size="mini" type="danger" @click="closePopup()">Đóng</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ShopExpiresPopup",
  props: ["accounts"],
  data() {
    return {
      showPopup: true
    };
  },
  methods: {
    reLogin() {
      this.closePopup();
      this.$router.push({ path: this.app.loginZalo });
    },
    closePopup() {
      this.showPopup = false;
    }
  }
};
</script>

<style scoped>

</style>